<template>
    <div class="wrapper-companies-list">
        <div class="card fts-table-wrapper">
            <div class="card-header">
                <div>Companies</div>
            </div>
            <div class="card-body">
                <div class="filter-row">
                    <div class="left-side">
                        <div class="search-box">
                            <b-form-group>
                                <b-input-group>
                                    <input type="text" class="form-control"  v-model="filter" v-on:keyup="searchKeyUp" v-on:keydown="searchKeyDown" placeholder="Search" />
                                </b-input-group>
                            </b-form-group>
                        </div>
                        <button class="btn btn-primary btn-mobile" @click="showMobileOptions()">Options</button>
                        <div class="display-disabled-box">
                            <c-switch class="mx-1" color="primary" id="hideDisabledCompanies" label variant="3d" dataOn="✓" dataOff="✕" v-model="hideDisabled" @change.native="getCompaniesList(true)"/>
                            <label>Show disabled companies</label>
                        </div>
                    </div>
                    <div class="size-page-wrapper text-right">
                        <label for="size-page">Display:</label>
                        <select v-on:change="sizePage" v-model="sortSettings.size" id="size-page" class="form-control custom-select">
                            <option value="40">40</option>
                            <option value="60">60</option>
                            <option value="80">80</option>
                            <option value="100">100</option>
                        </select>
                    </div>
                </div>
                <div class="fts-table table-responsive-sm">
                    <table v-if='companiesList' class="table b-table table-striped table-hover b-table-selectable b-table-select-multi table-managment fts-table companies-table">
                        <thead role="rowgroup">
                            <tr role="row">
                                <th v-on:click="changesSort(1)" :aria-sort="setAreaSort(1)">ID</th>
                                <th v-on:click="changesSort(2)" :aria-sort="setAreaSort(2)">Name</th>
                                <th v-on:click="changesSort(3)" :aria-sort="setAreaSort(3)">Pay Options</th>
                                <th v-on:click="changesSort(4)" :aria-sort="setAreaSort(4)">Card on File</th>
                                <th v-on:click="changesSort(5)" :aria-sort="setAreaSort(5)">Current Balance</th>
                                <th v-on:click="changesSort(6)" :aria-sort="setAreaSort(6)">Has agreement</th>
                                <th v-on:click="changesSort(7)" :aria-sort="setAreaSort(7)">Last successful payment</th>
                                <th role="columnheader" aria-colindex="6" aria-label="Last Active">Login</th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr v-for="company in companiesList" v-bind:key="company.companyId" :class="company.disabledAt && company.disabledAt != null ? 'company-disabled' : ''">
                                <td @click="showDetailsCompany(company.companyId)">{{company.companyId}}</td>
                                <td @click="showDetailsCompany(company.companyId)">{{company.companyName}}</td>
                                <td v-if="company.walletMode == 'PREPAID'" @click="showDetailsCompany(company.companyId)">Prepaid</td>
                                <td v-if="company.walletMode == 'OFFLINE_BILLING'" @click="showDetailsCompany(company.companyId)">Offline Billing</td>
                                <td v-if="company.walletMode == 'HYBRID_TERMS'" @click="showDetailsCompany(company.companyId)">Hybrid Terms</td>
                                <td @click="showDetailsCompany(company.companyId)">
                                    <span v-if="company.activeCreditCardPresent == true">Yes</span>
                                    <span v-else>No</span>
                                </td>
                                <td @click="showDetailsCompany(company.companyId)">
                                    <span v-if="company.walletMode != 'OFFLINE_BILLING'">$ {{company.balance}}</span>
                                    <span v-else>--</span>
                                </td>
                                <td @click="showDetailsCompany(company.companyId)">
                                    <span v-if="company.hasAgreement">Yes</span>
                                    <span v-else>No</span>
                                </td>
                                <td @click="showDetailsCompany(company.companyId)">
                                    <span v-if=company.lastSuccessfulPaymentAt>{{company.lastSuccessfulPaymentAt}}</span>
                                    <span v-else>--</span>
                                </td>
                                <td>
                                    <button @click="loginCompany(company.companyId, company.companyName, company.walletMode, company.hasColdStockAccess, company.tier2Roaming, company.voiceAccess, company.hotSpotAccess, company.nbIoTPlans, company.catM1Plans, company.simonActiveReady, company.displayedCarriers)" class="btn btn-primary btn-login-company">
                                        Login
                                        <i class="fa fa-sign-in"></i>
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div class="fts-bottom-table">
                    <b-button variant="link" @click="showExportSelect()">Export all SIMs</b-button>
                    <nav v-if="paginationCount" class="table-navigation" aria-label="Page navigation example">
                        <Paginate :page-count="paginationCount" v-model="sortSettings.page" :click-handler="paginationControll" :prev-text="'Prev'" :next-text="'Next'" :container-class="'pagination justify-content-center'" :page-class="'page-item'" :page-link-class="'page-link'" :prev-class="'page-item'" :prev-link-class="'page-link'" :next-class="'page-item'" :next-link-class="'page-link'"></Paginate>
                    </nav>
                    <b-button variant="primary" @click="showCompaniesExportSelect()">Export companies</b-button>
                </div>

                <div class="loader-companies-list" v-if="loadingCompniesList && noCompanies == false">
                    <div class="sk-wave">
                        <div class="sk-rect sk-rect1"></div>&nbsp;<div class="sk-rect sk-rect2"></div>&nbsp;<div class="sk-rect sk-rect3"></div>&nbsp;<div class="sk-rect sk-rect4"></div>&nbsp;<div class="sk-rect sk-rect5"></div>&nbsp;
                    </div>
                </div>

                <div class="no-companies" v-if="loadingCompniesList == false && noCompanies == true">
                    <h2 class="text">You have no Companies</h2>
                </div>
            </div>
        </div>
        <b-modal size="md" ref="fileFormatModal" id="fileFormatModal" centered hide-footer>
            <div class="file-format-popup">
                <img src="../../assets/img/file-format.svg">
                <h3>Save export file as:</h3>
                <div>
                    <button class="btn btn-primary csv" v-on:click="exportCsv">CSV</button>
                    <button class="btn btn-primary xls" v-on:click="exportXlsx">XLSX</button>
                </div>
                <button class="btn btn-light" @click="hideExportSelect()">Cancel</button>
            </div>
        </b-modal>
        <b-modal size="md" ref="companiesFileFormatModal" id="companiesFileFormatModal" centered hide-footer>
            <div class="file-format-popup">
                <img src="../../assets/img/file-format.svg">
                <h3>Save export file as:</h3>
                <div>
                    <button class="btn btn-primary csv" v-on:click="exportCompaniesCsv">CSV</button>
                    <button class="btn btn-primary xls" v-on:click="exportCompaniesXlsx">XLSX</button>
                </div>
                <button class="btn btn-light" @click="hideCompaniesExportSelect()">Cancel</button>
            </div>
        </b-modal>
        <b-modal size="md" ref="mobileOptions" id="mobileOptions" centered hide-footer>
            <template #modal-title>
                Options
            </template>
            <div>
                <div class="options-wrapper">
                    <div class="option-item">
                        <label for="mobile-size-showing">Item shown in table:</label>
                        <select v-on:change="sizePage" v-model="sortSettings.size" id="mobile-size-showing" class="form-control custom-select">
                            <option value="40">40</option>
                            <option value="60">60</option>
                            <option value="80">80</option>
                            <option value="100">100</option>
                        </select>
                    </div>

                    <div class="option-item">
                        <label for="disable-company">Show disabled companies</label>
                        <c-switch class="mx-1" color="primary" id="disable-company" label variant="3d" dataOn="✓" dataOff="✕" v-model="hideDisabled" @change.native="getCompaniesList(true)"/>
                    </div>
                </div>
            </div>
            <template #modal-footer>
                <button class="btn btn-default">Cancel</button>
                <button class="btn btn-primary">Apply</button>
            </template>
        </b-modal>
    </div>
</template>

<script>
import Vue from 'vue';
import Axios from 'axios'
import globalStore from './../../variables'
import Paginate from 'vuejs-paginate'
import VueSession from "vue-session";
import VueCookies from 'vue-cookies';
import { Switch as cSwitch } from "@coreui/vue";
Vue.use(VueCookies);
Vue.$cookies.config('7d','','',true)

Vue.use(VueSession);


export default {
    name: 'Companies',
    data() {
        return {
            filter: null,
            pagination: {
                lenght: 0,
                min: 1,
                max: 0
            },
            companiesList: true,
            sortSettings: {
                page: 1,
                size: 40,
                sort: 2,
                desc: false
            },
            paginationCount: 0,
            searchString: '',
            loadingCompniesList: true,
            noCompanies: false,
            timerSearch: '',
            hideDisabled: true
        }
    },
    components: {
        Paginate,
        cSwitch
    },
    methods: {
        showMobileOptions() {
            this.$refs['mobileOptions'].show();
        },
        hideMobileOptions() {
            this.$refs['mobileOptions'].hide();
        },
        hideExportSelect() {
            this.$refs['fileFormatModal'].hide()

        },
        showExportSelect() {
            this.$refs['fileFormatModal'].show()
        },
        hideCompaniesExportSelect() {
            this.$refs['companiesFileFormatModal'].hide()

        },
        showCompaniesExportSelect() {
            this.$refs['companiesFileFormatModal'].show()
        },
        exportCsv() {
            this.loadingCompniesList = true
            this.$refs['fileFormatModal'].hide()

            Axios.get(globalStore.data.restApiUrl + "/sims/all/csv")
                .then(response => {
                    let csvContent = "data:text/csv;charset=utf-8," + response.data;
                    var fileLink = document.createElement('a');fileLink.href = csvContent;
                    fileLink.setAttribute('download', 'simon_sims.csv');
                    document.body.appendChild(fileLink);
                    fileLink.click();
                    this.loadingCompniesList = false;
                }).catch(error => {
                this.$notify({
                    type: 'error',
                    group: 'notification',
                    title: 'SIMs export went wrong',
                    text: 'Something went wrong during SIMs export. Please contact with support.',
                    duration: 3000,
                });
                console.log(error);
            });
        },
        exportXlsx() {
            this.loadingCompniesList = true
            this.$refs['fileFormatModal'].hide()

            Axios.get(globalStore.data.restApiUrl + "/sims/all/xlsx", {responseType: 'blob'})
                .then((response) => {
                    const fileLink = URL.createObjectURL(new Blob([response.data],
                        {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,'}
                        )
                    );
                    const link = document.createElement('a')
                    link.href = fileLink
                    link.setAttribute('download', 'simon_sims.xlsx')
                    document.body.appendChild(link)
                    link.click()
                    this.loadingCompniesList = false;
                }).catch(error => {
                this.$notify({
                    type: 'error',
                    group: 'notification',
                    title: 'SIMs export went wrong',
                    text: 'Something went wrong during SIMs export. Please contact with support.',
                    duration: 3000,
                });
                console.log(error);
            });
        },
        exportCompaniesCsv() {
            this.hideCompaniesExportSelect();

            Axios.get(globalStore.data.restApiUrl + "/admin/accounts/csv")
                .then(response => {
                    let csvContent = "data:text/csv;charset=utf-8," + response.data;
                    var fileLink = document.createElement('a');fileLink.href = csvContent;
                    fileLink.setAttribute('download', 'companies list.csv');
                    document.body.appendChild(fileLink);
                    fileLink.click();
                }).catch(error => {
                this.$notify({
                    type: 'error',
                    group: 'notification',
                    title: 'SIMs export went wrong',
                    text: 'Something went wrong during SIMs export. Please contact with support.',
                    duration: 3000,
                });
                console.log(error);
            });
        },
        exportCompaniesXlsx() {
            this.hideCompaniesExportSelect()

            Axios.get(globalStore.data.restApiUrl + "/admin/accounts/xlsx", {responseType: 'blob'})
                .then((response) => {
                    const fileLink = URL.createObjectURL(new Blob([response.data],
                        {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,'}
                        )
                    );
                    const link = document.createElement('a')
                    link.href = fileLink
                    link.setAttribute('download', 'companies list.xlsx')
                    document.body.appendChild(link)
                    link.click()
                }).catch(error => {
                this.$notify({
                    type: 'error',
                    group: 'notification',
                    title: 'SIMs export went wrong',
                    text: 'Something went wrong during SIMs export. Please contact with support.',
                    duration: 3000,
                });
                console.log(error);
            });
        },
        searchKeyUp() {
            clearTimeout(this.timerSearch)
            this.timerSearch = setTimeout(() => {
                this.searchRow()
            }, 500)
        },
        searchKeyDown() {
            clearTimeout(this.timerSearch)
        },
        showDetailsCompany(id) {
            this.$router.push(`/admin/company/${id}`)
        },
        getCompaniesList(notPagination) {
            if (notPagination) {
                this.sortSettings.page = 1;
                this.getPagination();
            }

            const requestUrl = new URL(location.href),
                  requestHost = requestUrl.host;

            Axios.get(globalStore.data.restApiUrl + `/admin/accounts?page=${this.sortSettings.page}&size=${this.sortSettings.size}&sort=${this.sortSettings.sort}&desc=${this.sortSettings.desc}&hideDisabled=${!this.hideDisabled}${this.searchString}`)
                .then(response => {
                    this.companiesList = [];
                    let companies = response.data.selectedCompanies.response
                    for (let company of companies) {
                        let template = company
                        if (company.companyPermissions.indexOf('COLD_STOCK_ACCESS') > -1) {
                            template.hasColdStockAccess = true
                        } else {
                            template.hasColdStockAccess = false
                        }

                        if (company.companyPermissions.indexOf('TIER_2_INTERNATIONAL_ROAMING') > -1) {
                            template.tier2Roaming = true
                        } else {
                            template.tier2Roaming = false
                        }

                        if (company.companyPermissions.indexOf('VOICE_ACCESS') > -1) {
                            template.voiceAccess = true
                        } else {
                            template.voiceAccess = false
                        }

                        if (company.companyPermissions.indexOf('HOT_SPOT_PLANS_ACCESS') > -1) {
                            template.hotSpotAccess = true
                        } else {
                            template.hotSpotAccess = false
                        }

                        if (company.companyPermissions.indexOf('NB_IOT_PLANS_ACCESS') > -1) {
                            template.nbIoTPlans = true
                        } else {
                            template.nbIoTPlans = false
                        }

                        if (company.companyPermissions.indexOf('CAT_M1_PLANS_ACCESS') > -1) {
                            template.catM1Plans = true
                        } else {
                            template.catM1Plans = false
                        }

                        if (company.companyPermissions.indexOf('NETCRACKER_ACTIVE_READY') > -1) {
                            template.simonActiveReady = true
                        } else {
                            template.simonActiveReady = false
                        }

                        template.balance = Number(company.balance).toLocaleString('en-US', {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                        })

                        this.companiesList.push(template)
                    }

                    if (this.companiesList == undefined) {
                        this.loadingCompniesList = false;
                        this.noCompanies = true;
                    } else {
                        this.loadingCompniesList = false;
                        this.noCompanies = false;
                    }

                }).catch(error => {
                    this.$notify({
                        type: 'warn',
                        group: 'notification',
                        title: 'Getting data error',
                        text: 'Error Retrieving Company List - Contact Support',
                        duration: 5000,
                    });
                    console.log(error)
                })
        },
        searchRow: function () {
            this.loadingCompniesList = true;
            this.searchString = '&search=' + escape(this.filter);
            this.getCompaniesList(true)
        },
        sizePage: function () {
            this.loadingCompniesList = true;
            this.getCompaniesList(true);
        },
        changesSort(sortId) {
            if (sortId == this.sortSettings.sort) {
                this.sortSettings.desc = !this.sortSettings.desc
            }
            this.sortSettings.sort = sortId
            this.getCompaniesList(true)
        },
        setAreaSort(sortId) {
            if (sortId != this.sortSettings.sort) {
                return 'none'
            } else if (sortId == this.sortSettings.sort && this.sortSettings.desc) {
                return 'descending'
            } else if (sortId == this.sortSettings.sort && this.sortSettings.desc == false) {
                return 'ascending'
            }
        },
        getPagination() {
            Axios.get(globalStore.data.restApiUrl + "/admin/accounts-page-count?size=" + this.sortSettings.size + '&hideDisabled=' + !this.hideDisabled + this.searchString)
                .then(response => {
                    if (response.status == 200) {
                        this.paginationCount = Number (response.data);
                    } else {
                        this.$notify({
                            type: 'warn',
                            group: 'notification',
                            title: 'Getting data error',
                            text: 'Error Sorting Company List - Contact Support',
                            duration: 5000,
                        });
                        console.log(response)

                        return false;
                    }
                }).catch(error => {
                    this.$notify({
                        type: 'warn',
                        group: 'notification',
                        title: 'Getting data error',
                        text: 'Error Sorting Company List - Contact Support',
                        duration: 5000,
                    });
                    console.log(error)

                    return false;
                })
        },
        paginationControll(ev) {
            this.loadingSimList = true;
            this.sortSettings.page = ev;
            this.getCompaniesList(false);
        },
        loginCompany(id, name, typeAccount, coldStockAccess, tier2Roaming, voiceAccess, hotSpotAccess, nbIoTPlans, catM1Plans, simonActiveReady, carriersList) {
            this.$session.set('companyId', id);
            this.$session.set('companyName', name);
            this.$session.set('typeAccount', typeAccount);
            this.$session.set('coldStockAccess', coldStockAccess);
            this.$session.set('tier2Roaming', tier2Roaming);
            this.$session.set('voiceAccess', voiceAccess);
            this.$session.set('hotSpotAccess', hotSpotAccess);
            this.$session.set('nbIoTPlans', nbIoTPlans);
            this.$session.set('catM1Plans', catM1Plans);
            this.$session.set('simonActiveReady', simonActiveReady);
            this.$session.set('loggedFromList', true)
            if (carriersList.indexOf(1) > -1) {
                this.$session.set('simonCarrierAvailable', true)
            } else {
                this.$session.set('simonCarrierAvailable', false)
            }
            if (carriersList.indexOf(2) > -1) {
                this.$session.set('tmobileCarrierAvailable', true)
            } else {
                this.$session.set('tmobileCarrierAvailable', false)
            }
            if (carriersList.indexOf(3) > -1) {
                this.$session.set('vodafoneCarrierAvailable', true)
            } else {
                this.$session.set('vodafoneCarrierAvailable', false)
            }
            if (carriersList.indexOf(4) > -1) {
                this.$session.set('koreCarrierAvailable', true)
            } else {
                this.$session.set('koreCarrierAvailable', false)
            }
            this.$session.set('loggedFromList', true)
            this.$router.push("/dashboard");
        }
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            if (((from.path.indexOf('/admin/') > -1 && from.path.indexOf('/admin/company') > -1) || from.path.indexOf('/admin/') == -1) && from.path.indexOf('/login') == -1) {
                if (vm.$session.get('companiesSortSettings')) {
                    vm.sortSettings = vm.$session.get('companiesSortSettings')
                    vm.$session.remove('companiesSortSettings')
                }
                if (vm.$session.get('companiesSearch')) {
                    vm.searchString = vm.$session.get('companiesSearch')
                    vm.$session.remove('companiesSearch')
                }
                if (vm.$session.get('companiesFilter')) {
                    vm.filter = vm.$session.get('companiesFilter')
                    vm.$session.remove('companiesFilter')
                }
                if (vm.$session.get('companiesPaginationCount')) {
                    vm.paginationCount = vm.$session.get('companiesPaginationCount')
                    vm.$session.remove('companiesPaginationCount')
                }

                vm.getCompaniesList(false)

            } else {
                if (vm.$session.get('companiesSortSettings')) {
                    vm.$session.remove('companiesSortSettings')
                }
                if (vm.$session.get('companiesSearch')) {
                    vm.$session.remove('companiesSearch')
                }
                if (vm.$session.get('companiesFilter')) {
                    vm.$session.remove('companiesFilter')
                }
                if (vm.$session.get('companiesPaginationCount')) {
                    vm.$session.remove('companiesPaginationCount')
                }

                vm.sortSettings = {
                    page: 1,
                    size: 40,
                    desc: false,
                    sort: 2
                }
                vm.searchString = ''
                vm.filter = ''

                vm.getCompaniesList(true)
            }
        })
    },
    beforeDestroy() {
        this.$session.set('companiesSortSettings', this.sortSettings)
        this.$session.set('companiesSearch', this.searchString)
        this.$session.set('companiesFilter', this.filter)
        this.$session.set('companiesPaginationCount', this.paginationCount)
    }
}
</script>

<style src="spinkit/scss/spinkit.scss" lang="scss" />
<style lang="scss">
.size-page {
    display: flex;
    justify-content: flex-end;
    align-content: center;
    align-items: center;

    label {
        margin: 0;
    }

    select {
        margin-left: 10px;
        max-width: 100px;
    }
}

.btn-login-company {
    background-color: #00C4B0;
    border-color: #00C4B0;
    font-size: 14px;
    font-weight: 700;
    i {
        margin-left: 12px;
        font-size: 26px;
        vertical-align: middle;
    }
}

.loader-companies-list,
.no-companies {
    position: absolute;
    top: 120px;
    right: 0;
    bottom: 0;
    left: 0;

    background-color: rgba(255, 255, 255, 0.7);

    display: flex;
    justify-content: center;
    align-items: center;
    align-content: center;

    .sk-wave {
        height: 60px;
        .sk-rect {
            width: 3px;
            background-color: #39c354;
            border-radius: 4px;
        }
    }

    .text {
        margin-top: 20px;
        text-align: center;
        font-size: 15px;
        font-weight: 700;
    }
}

.no-companies {
    position: relative;
    top: 0;
    h2.text {
        margin-top: 10px;
    }
}

.wrapper-companies-list {
    .fts-table-wrapper {

        .card-body {
            .filter-row {
                .left-side {
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    .display-disabled-box {
                        display: flex;
                        align-items: center;
                        margin-left: 40px;
                        label {
                            margin: 0 0 0 12px;
                        }
                    }
                }
            }
        }
    }
    .fts-bottom-table {
        display: flex;
        justify-content: space-between;
    }
}

.companies-table {
    tbody {
        .company-disabled {
            td {
                background-color: #ffe3e3 !important;
            }
        }
    }
}

.dark-theme {
    .loader-companies-list,
    .no-companies {
        background-color: rgba(0, 0, 0, 0.4);
    }

    .table thead th {
        color: #fff;
        border-color: #1A1C1D;
    }
    .table tbody tr td {
        border-color: #1A1C1D;
        color: #fff;
    }
    .table tbody tr:nth-of-type(even) td {
        background-color: #3a4149;
    }
    .table tbody tr:nth-of-type(odd) td {
        background-color: #383e45;
    }
    .table tbody tr:hover td {
        background-color: #0088FF;
        color: #fff;
    }
    .table tbody tr[aria-selected="true"] td {
        background-color: #0088FF;
        color: #fff;
    }

    #fileFormatModal___BV_modal_content_,
    #companiesFileFormatModal___BV_modal_content_ {
        background-color: #3a4149;
        color: #EDEEEF;

        button {
            color: #fff;
        }
        .file-format-popup {
            background-color: #3a4149;
            color: #EDEEEF;
        }

        .modal-body {
            button.btn-light {
                color: #23282c;
            }
        }
    }

    .companies-table {
        tbody {
            .company-disabled {
                td {
                    background-color: #493a3a !important;
                }
            }
        }
    }
}

#fileFormatPopup___BV_modal_content_ {
    text-align: center;
    header {
        padding-bottom: 0
    }
    .modal-body {
        padding-top: 0;

        h3 {
            font-size: 15px;
            margin-top: 8px;
            margin-bottom: 20px;
        }

        button {
            margin: 0 10px 20px;

            &.btn-light {
                margin: 10px 0 0;
            }
        }
    }
}
#fileFormatModal___BV_modal_header_ {
    padding-bottom: 0;
}
#fileFormatModal___BV_modal_body_,
#companiesFileFormatModal___BV_modal_body_{
    padding-top: 0;
    .file-format-popup {
        display: flex;
        flex-direction: column;
        align-items: center;
        background-color: #fff;
        padding: 0 20px 20px;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        border-radius: 5px;

        h3 {
            font-size: 15px;
            margin-top: 8px;
            margin-bottom: 20px;
        }

        .btn {
            width: 100px;
        }

        .btn-primary {
            margin: 0 10px 20px;
        }

        .btn-light {
            margin: 10px 0 0;
        }

        .csv {
            background-color: #00559F;
            border-color: #00559F;
        }
        .xls {
            background-color: #207245;
            border-color: #207245;
        }

        .close-icon {
            position: absolute;
            top: 20px;
            right: 20px;
            cursor: pointer;
        }
    }
}

#fileFormatPopup___BV_modal_content_ {
    text-align: center;
    header {
        padding-bottom: 0
    }
    .modal-body {
        padding-top: 0;

        h3 {
            font-size: 15px;
            margin-top: 8px;
            margin-bottom: 20px;
        }

        button {
            margin: 0 10px 20px;

            &.btn-light {
                margin: 10px 0 0;
            }
        }
    }
}

.btn-mobile {
    display: none;
}
</style>
